import Router from './router'
import 'antd/dist/reset.css';
import './style.scss'
function App() {

    return <Router/>

    }
export default App